import React from "react";
import "./styles.css";
import { CHAT_DURATION_SECONDS } from "../../../../gameConfig";

const debateMinutes = Math.round(CHAT_DURATION_SECONDS / 60);

const bodyParagraphStyle: React.CSSProperties = {
    margin: "0 0 14px 0",
    lineHeight: "1.6",
};

const Instructions = () => {
    return (
        <span
            className="text"
            style={{
                padding: "24px 100px",
                display: "inline-block",
                textAlign: "justify",
                textJustify: "inter-word",
                width: "90vw",
                boxSizing: "border-box",
            }}
        >
            <p style={bodyParagraphStyle}>
                <strong style={{ fontSize: "18px", color: "#1e293b" }}>Welcome! 🎯</strong>
            </p>

            <p style={bodyParagraphStyle}>
                This study takes about <strong>15-20 minutes</strong>.
            </p>

            <p style={bodyParagraphStyle}>
                You&apos;ll first complete a brief tutorial and a short practice round (against a computer player) to learn{" "}
                <strong style={{ color: "#0284c7" }}>Task 2</strong>. Afterward, you&apos;ll wait to be matched with a real partner. Matching may take a few moments.
            </p>

            <div
                style={{
                    backgroundColor: "#f0f9ff",
                    border: "2px solid #0ea5e9",
                    borderRadius: "12px",
                    padding: "20px",
                    marginBottom: "24px",
                    textAlign: "left",
                }}
            >
                <h2
                    style={{
                        margin: "0 0 16px 0",
                        fontSize: "22px",
                        fontWeight: 700,
                        color: "#0369a1",
                        textAlign: "center",
                    }}
                >
                    Main Study (2 Parts)
                </h2>
                <p
                    style={{
                        margin: "0 0 12px 0",
                        fontSize: "16px",
                        fontWeight: 500,
                        color: "#0c4a6e",
                        lineHeight: "1.7",
                    }}
                >
                    <strong style={{ color: "#0284c7" }}>1. Discussion Chat (Task 1) 🔥</strong>
                    <br />
                    Once matched, you and your partner will discuss an assigned topic for{" "}
                    <strong>{debateMinutes} minutes</strong>. We&apos;ll ask a few questions before and after the discussion. Thoughtful participation may earn an additional bonus.
                </p>
                <p
                    style={{
                        margin: "0",
                        fontSize: "16px",
                        fontWeight: 500,
                        color: "#0c4a6e",
                        lineHeight: "1.7",
                    }}
                >
                    <strong style={{ color: "#0284c7" }}>2. One Investment Round (Task 2) 💰</strong>
                    <br />
                    After the discussion, you play <strong>only one</strong> investment round. You and your partner each start with <strong>30 coins</strong> and decide how many to invest in a shared pot. The total invested amount grows and is then split equally between both players.
                </p>
            </div>

            {/* Previous layout (kept for reference):
            <p>... 4 game rounds ... After Round 3, 5-minute debate ... Rounds 1-3 up to $0.50, Round 4 up to $1.50 ...</p>
            */}

            <p style={bodyParagraphStyle}>
                <strong style={{ color: "#0284c7" }}>The more you and your partner invest, the more both of you can earn.</strong>{" "}
                However, because rewards are shared equally, contributing less than your partner can sometimes result in a higher personal payoff. You may choose to play{" "}
                <strong style={{ color: "#dc2626" }}>cooperatively or competitively</strong>.
            </p>

            <p style={bodyParagraphStyle}>
                <strong>Bonus:</strong> Coins earned in the investment round are converted into real money 
                {/* (up to{" "}<strong style={{ color: "#dc2626" }}>$1.50</strong>) */}
                . <strong>The more coins you earn, the larger your bonus for this task.</strong>
            </p>

            <div
                style={{
                    backgroundColor: "#fef3c7",
                    border: "1px solid #fbbf24",
                    borderRadius: "6px",
                    padding: "10px 14px",
                    margin: "0 0 14px 0",
                    textAlign: "center",
                }}
            >
                <strong style={{ color: "#92400e" }}>Remember:</strong>
                <span style={{ color: "#78350f", marginLeft: "6px" }}>
                    Higher earnings in the one investment round increase your bonus, and thoughtful discussion participation may earn an additional reward.
                </span>
            </div>

            <p style={{ margin: "0", fontSize: "16px", fontWeight: 600, color: "#1e293b", textAlign: "center" }}>
                Good luck, and enjoy the game!
            </p>
        </span>
    );
};

export default React.memo(Instructions);
